import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useAPI from "../../../../api/hooks/useAPI";
import { webhookConfigKeys } from "../../../../api/queryKeys";

const useWebhookConfig = (toolName) => {
  const queryClient = useQueryClient();
  const api = useAPI();

  const apiMap = {
    torq: {
      get: api.getTorqConfig,
      update: api.updateTorqConfig,
    },
    splunk_cloud: {
      get: api.getSplunkCloudConfig,
      update: api.updateSplunkCloudConfig,
    },
    paloalto_cortex_xsiam: {
      get: api.getPaloAltoCortexXSIAMConfig,
      update: api.updatePaloAltoCortexXSIAMConfig,
    },
    coralogix: {
      get: api.getCoralogixConfig,
      update: api.updateCoralogixConfig,
    },
    sumologic: {
      get: api.getSumoLogicConfig,
      update: api.updateSumoLogicConfig,
    },
    workato: {
      get: api.getWorkatoConfig,
      update: api.updateWorkatoConfig,
    },
  };

  const {
    data: config,
    isLoading,
    error,
  } = useQuery({
    queryKey: webhookConfigKeys.webhookConfig(toolName),
    queryFn: async () => {
      const response = await apiMap[toolName].get();
      return response.data;
    },
    enabled: !!apiMap[toolName],
  });

  const mutation = useMutation({
    mutationFn: (newConfig) => apiMap[toolName].update(newConfig),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: webhookConfigKeys.webhookConfig(toolName),
      });
    },
  });

  return {
    config,
    isLoading,
    error,
    updateConfig: mutation.mutateAsync,
    isUpdating: mutation.isPending,
  };
};

export default useWebhookConfig;
